export enum ExternalOrderProviderStatusNote {
	CANCELLED = 'cancelled',
	FAILED = 'failed',
	REJECTED = 'rejected'
}
